export enum AvailabilityCircleColor {
    red = 'util-red',
    orange = 'util-orange',
    green = 'util-green',
}
